var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import firebase from "../config";
import { useEffect, useState } from "react";
import moment from "moment";
export function useTours(hotReload, filterStatus, start, end) {
    var _this = this;
    var _a = useState([]), tours = _a[0], setTours = _a[1];
    var _b = useState(function () { }), listener = _b[0], setListener = _b[1];
    // ToDo: Further error handling
    useEffect(function () {
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var user, query, data, data_1, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // If there is an old hot reload listener, unsubscribe
                        try {
                            listener();
                            setListener(function () { });
                        }
                        catch (e) { }
                        user = firebase.auth().currentUser;
                        if (!user) {
                            throw new Error("Unauthenticated");
                        }
                        query = firebase
                            .firestore()
                            .collection("tours")
                            .where("owner", "==", user.uid)
                            .where("status", "in", filterStatus !== null && filterStatus !== void 0 ? filterStatus : ["prepared", "ontheway"])
                            .orderBy("processed_date", "desc");
                        return [4 /*yield*/, query.get()];
                    case 1:
                        data = (_a.sent()).docs.map(function (docs) { return docs; });
                        console.log("data");
                        console.log(data);
                        // Add start and end filters, if both are set
                        if (start && end) {
                            query = query
                                .where("processed_date", ">=", moment().startOf("day").toDate())
                                .where("processed_date", "<=", moment().endOf("day").toDate());
                        }
                        if (!(hotReload !== null && hotReload !== void 0 ? hotReload : false)) return [3 /*break*/, 2];
                        setListener(query.onSnapshot(function (snap) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                setTours(snap.docs.map(function (rawTour) { return rawTour.data(); }));
                                return [2 /*return*/];
                            });
                        }); }));
                        return [3 /*break*/, 5];
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, query.get()];
                    case 3:
                        data_1 = (_a.sent()).docs.map(function (rawTour) { return rawTour.data(); });
                        setTours(data_1);
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); })();
    }, [hotReload, start, end]);
    return tours;
}
export var ALL_TOUR_STATES = [
    "empty",
    "prepared",
    "ontheway",
    "finished",
];
